import {default as ym} from "react-yandex-metrika";
import React, {useEffect} from "react";
import * as Sentry from "@sentry/react";
import {useCurrentUser} from "~/auth/hooks";


export const Analytics = () => {
    const [user, userLoading] = useCurrentUser();


    useEffect(() => {
        ym("getClientID", clientId => {
            Sentry.configureScope(scope => {
                Sentry.setUser({
                    ...scope.getUser(),
                    ym_client_id: clientId,
                });
            });
        });
    }, []);


    useEffect(() => {
        if (userLoading) {
            return;
        }

        if (user) {
            ym("userParams", {
                username: user.userName
            });

            Sentry.configureScope(scope => {
                Sentry.setUser({
                    ...scope.getUser(),
                    username: user.userName
                });
            });
        } else {
            ym("userParams", {
                username: null
            });
        }
    }, [user, userLoading]);

    return null;
}